export default {
  choose_preferred_wallet: "Choisissez votre portefeuille préféré",
  connect_mobile_wallet: "Se connecter au portefeuille mobile",
  scan_qrcode_with_wallet: "Scannez le QR code avec un portefeuille compatible WalletConnect",
  return_to_mobile_options: "Retour aux options du portefeuille mobile",
  view_qrcode_option: "Voir le QR code",
  connect: "Se connecter",
};
